// @flow

import React, { Component }                     from 'react';
import { connect }                              from 'react-redux';
import { getTranslate }                         from 'react-localize-redux';
import { userGetPersonalInfo, setNotification,
         sendDestroyAccountMail }               from 'actions/user/user';
import documentHelper                           from 'helpers/document.helper';
import GeneralSettings                          from 'components/main/settings/generalSettings.js';
import Notifications                            from 'components/main/settings/notifications.js';
import AccountDelete                            from 'components/main/settings/accountDelete.js';
import DeleteModal                              from 'components/main/settings/deleteModal.js';
import { setActiveApplication }                 from 'actions/applications/applications'


import './index.css';

class Settings extends Component {

  constructor() {
    super();

    this._changeToggle = this._changeToggle.bind(this);
    this._addLabels = this._addLabels.bind(this);
    this._deleteAccount = this._deleteAccount.bind(this);
  }

  componentWillMount() {
    const { translate } = this.props;
    documentHelper.setTitle(translate('settings.title'));
  }

  // load phone number and add labels
  componentDidMount() {
    const { getInfo } = this.props;
    getInfo();
    this._addLabels();

    this.getApplication();
  }

  // append label to each checkbox
  _addLabels = () => {
    let checkBoxes = document.getElementsByClassName('check-box');
    [].forEach.call(checkBoxes, (item) => {
      let label = document.createElement('label');
      label.setAttribute('for', item.querySelector('input').getAttribute('id'));
      item.appendChild(label);
    });
  };

  getApplication() {
    const { setActiveApplication, applications } = this.props;
    const appId = localStorage.getItem('app_current');
    const appOrderId = appId ? appId.slice(1,-1) : null;

    if (appOrderId) {
      const application = applications.find(item => item.order_id === appOrderId);
      if (application) { setActiveApplication(application) };
    }
  }

  // update starfish_user model on checkbox change
  _changeToggle = (e, type) => {
    const { setNotification } = this.props;
    setNotification(type, e.target.checked);
  };

  _deleteAccount = () => {
    const { sendDestroyMail, history } = this.props;
    sendDestroyMail().then((res) => {
      history.push('/mail-has-been-sent');
    });
  };

  render() {
    const { email, sms_notification, mail_notification, primary_phone, subscribed_to_newsletter } = this.props.user;
    const { translate, activeApp } = this.props;

    return (
      <div className="settings-area">
        <DeleteModal
          translate={translate}
          deleteAccount={this._deleteAccount}
        />
        <div className="container-fluid">
          {activeApp && <Notifications
            application={activeApp}
            sms_notification={sms_notification}
            mail_notification={mail_notification}
            primary_phone={primary_phone}
            subscribedToNewsletter={subscribed_to_newsletter}
            translate={translate}
            email={email}
            changeToggle={this._changeToggle}
          />}
          <GeneralSettings
            translate={translate}
            subscribedToNewsletter={subscribed_to_newsletter}
            changeToggle={this._changeToggle}
          />
        <AccountDelete translate={translate} />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = ({
  getInfo: userGetPersonalInfo,
  setNotification: setNotification,
  sendDestroyMail: sendDestroyAccountMail,
  setActiveApplication: setActiveApplication,
});

const mapStateToProps = state => ({
  user: state.user,
  applications: state.application.applications.rows,
  activeApp: state.application.activeApplication,
  translate: getTranslate(state.locale),
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);



// WEBPACK FOOTER //
// ./src/containers/settings/index.js